import React from 'react';
import './ZoneList.css';

const ZoneList = ({ zones, onEditZone, onDeleteZone, onGenerateQR }) => {
  if (!zones || zones.length === 0) {
    return (
      <div className="no-zones">
        <p>No zones available. Create your first zone!</p>
      </div>
    );
  }

  return (
    <div className="zones-table">
      <div className="zones-header">
        <div className="zone-cell">Name</div>
        <div className="zone-cell">Code</div>
        <div className="zone-cell">Hourly Rate</div>
        <div className="zone-cell">Actions</div>
      </div>
      {zones.map(zone => (
        <div key={zone.id} className="zone-row">
          <div className="zone-cell">{zone.name}</div>
          <div className="zone-cell">{zone.code}</div>
          <div className="zone-cell">${zone.hourly_rate?.toFixed(2)}</div>
          <div className="zone-cell">
            <div className="zone-actions">
              <button 
                onClick={() => onEditZone(zone)} 
                className="action-btn edit-btn"
                title="Edit zone"
              >
                Edit
              </button>
              <button 
                onClick={() => onGenerateQR(zone)} 
                className="action-btn qr-btn"
                title="Generate QR code"
              >
                QR Code
              </button>
              <button 
                onClick={() => onDeleteZone(zone.id)} 
                className="action-btn delete-btn"
                title="Delete zone"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ZoneList; 